import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center -mb-12 sm:-mb-20 lg:-mb-[104px]">
      <h1 className="text-6xl font-extrabold text-gray-800 mb-4">404</h1>
      <p className="text-xl md:text-2xl text-gray-600 mb-6">
        Oops! The page you are looking for does not exist.
      </p>
      <button
        onClick={() => navigate("/")}
        className="px-6 py-3 bg-[#1D43B6] text-white rounded-[12px] shadow-md hover:scale-95 transition-all duration-300 linear"
      >
        Go Back Home
      </button>
      
    </div>
  );
};

export default NotFound;